export default __webpack_public_path__ + "static/media/DIVA EX2.e523eaa6.jpg";